import React, { useState, useEffect } from "react";

const LOADING_MESSAGES = [
  "Planning Route",
  "Detecting Traffic",
  "Checking Weather",
  "Determining Road Conditions",
  "Finding Cameras",
];

const MapContainer = ({ mapRef, isCalculating }) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!isCalculating) {
      setMessageIndex(0);
      return;
    }
    const interval = setInterval(() => {
      setMessageIndex((i) => (i + 1) % LOADING_MESSAGES.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [isCalculating]);

  return (
    <div className="relative w-full h-full">
      <div
        ref={mapRef}
        style={{ width: "100%", height: "100%" }}
        className="overflow-hidden"
      />
      {isCalculating && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/30 z-10">
          <div className="flex flex-col items-center gap-3 bg-white dark:bg-gray-800 rounded-lg px-6 py-4 shadow-lg">
            <svg
              className="animate-spin h-8 w-8 text-blue-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
              {LOADING_MESSAGES[messageIndex]}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapContainer;
